import React from 'react';
import Head from 'next/head';
import {
  HREFLANG_ALTERNATES, OVERSEA_CANONICAL_URL, OVERSEA_HOME_DESCRIPTION,
  OVERSEA_HOME_KEYWORDS, OVERSEA_HOME_TITLE,
} from '@/pages/--oversea/seo';

/** 官网首页暂用现有英文 SEO 文案，待 Smartcat 正式 key 下发后接入对应语言。 */
export default function OfficialHomeHead() {
  return (
    <Head>
      <title>{OVERSEA_HOME_TITLE}</title>
      <meta name="description" content={OVERSEA_HOME_DESCRIPTION} />
      <meta name="keywords" content={OVERSEA_HOME_KEYWORDS} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={OVERSEA_HOME_TITLE} />
      <meta property="og:description" content={OVERSEA_HOME_DESCRIPTION} />
      <meta property="og:url" content={OVERSEA_CANONICAL_URL} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={OVERSEA_HOME_TITLE} />
      <meta name="twitter:description" content={OVERSEA_HOME_DESCRIPTION} />
      {/* 两种语言共用官网 URL，不将工作台 /home 标记为中文版官网。 */}
      <link rel="canonical" href={OVERSEA_CANONICAL_URL} />
      {HREFLANG_ALTERNATES.map(({ hreflang, href }) => (
        <link
          key={hreflang}
          rel="alternate"
          hrefLang={hreflang}
          href={href}
        />
      ))}
    </Head>
  );
}
